<div class="flex pt-2 pb-2 pr-2 flex-col justify-center items-center gap-4">
    <!-- Appointment Confirmed/Request Confirmed heading -->
    <div class="self-stretch text-xl font-medium text-text-primary">
        <span *ngIf="!isApprovalRequired && !isRequestAppointmentOnly"
            >Appointment {{ isRescheduleAppointment ? 'Rescheduled' : 'Confirmed' }}
        </span>
        <span *ngIf="isApprovalRequired && !isRequestAppointmentOnly">Request Confirmed</span>
        <span *ngIf="isRequestAppointmentOnly">Appointment Requested</span>
    </div>

    <!-- Confirmation Number section -->
    <div *ngIf="ticketID" class="flex items-center gap-2 self-stretch">
        <span class="text-md font-medium text-text-primary"> Confirmation Number: </span>
        <span class="text-md font-medium text-text-primary font-semibold">
            {{ ticketID }}
        </span>
    </div>

    <!-- Success notification -->
    <div class="flex p-3 items-start gap-2 self-stretch rounded-md bg-positive-light">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" class="flex-shrink-0">
            <path
                d="M10 3.5C11.7239 3.5 13.3772 4.18482 14.5962 5.40381C15.8152 6.62279 16.5 8.27609 16.5 10C16.5 11.7239 15.8152 13.3772 14.5962 14.5962C13.3772 15.8152 11.7239 16.5 10 16.5C8.27609 16.5 6.62279 15.8152 5.40381 14.5962C4.18482 13.3772 3.5 11.7239 3.5 10C3.5 8.27609 4.18482 6.62279 5.40381 5.40381C6.62279 4.18482 8.27609 3.5 10 3.5ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM12.6375 8.64687C12.8562 8.29688 12.75 7.83438 12.4 7.6125C12.05 7.39062 11.5875 7.5 11.3656 7.85L9.44688 10.9219L8.60313 9.79688C8.35313 9.46562 7.88438 9.39687 7.55312 9.64687C7.22187 9.89687 7.15312 10.3656 7.40312 10.6969L8.90312 12.6969C9.05 12.8937 9.2875 13.0062 9.53438 12.9969C9.78125 12.9875 10.0062 12.8562 10.1375 12.6438L12.6375 8.64375V8.64687Z"
                fill="#16A34A"
            />
        </svg>

        <div>
            <!-- Conditional messaging based on approval requirements -->
            <div class="text-sm font-medium text-text-primary font-semibold mb-1">
                <span *ngIf="!isApprovalRequired && !isRequestAppointmentOnly"
                    >Your appointment has been {{ isRescheduleAppointment ? 'rescheduled' : 'confirmed' }}!</span
                >
                <span *ngIf="isApprovalRequired && !isRequestAppointmentOnly">Your appointment has been requested!</span>
                <span *ngIf="isRequestAppointmentOnly">Your appointment has been requested!</span>
            </div>
            <div class="text-xs text-text-primary">
                Thank you <span class="text-xs font-semibold">{{ clientName }}</span
                >!
                <span *ngIf="!isApprovalRequired && !isRequestAppointmentOnly"> You will receive a confirmation email shortly.</span>
                <span *ngIf="isApprovalRequired && !isRequestAppointmentOnly">
                    Someone will reach out to you by email to confirm the appointment.</span
                >
                <span *ngIf="isRequestAppointmentOnly"> Someone will reach out soon about your appointment</span>
            </div>
        </div>
    </div>

    <!-- Appointment Details Card -->
    <div
        class="flex w-full bg-white rounded-md border border-base-border bg-base-bg"
        *ngIf="appointmentRequest?.service && !isRequestAppointmentOnly"
    >
        <!-- Date section -->
        <div class="flex items-center self-stretch rounded-l-md bg-primary-base/80 text-white min-w-[80px] px-4">
            <div class="flex flex-col items-center">
                <div class="text-white text-sm font-normal leading-[140%]">{{ getBookingDate | date: 'EEE' }}</div>
                <div class="text-white text-md font-semibold leading-[140%]">{{ getBookingDate | date: 'MMM d' }}</div>
                <div class="text-white text-sm font-normal leading-[140%]">{{ getBookingDate | date: 'yyyy' }}</div>
            </div>
        </div>

        <!-- Appointment details -->
        <div class="flex pl-4 py-2 pr-2 flex-col items-start gap-2 flex-1">
            <div class="flex justify-between items-center self-stretch">
                <div class="text-md text-text-primary">{{ getBookingTime }}</div>
                <div
                    class="flex h-8 px-4 justify-center items-center gap-1 rounded bg-primary-light"
                    *ngIf="shouldShowServicePrice && appointmentRequest?.service && appointmentRequest.service.length > 0"
                >
                    <span class="text-md font-semibold text-text-primary">
                        {{
                            getServicesPrice(appointmentRequest.service)
                                | currency
                                    : currencyCode
                                    : 'symbol'
                                    : (getServicesPrice(appointmentRequest.service) % 1 != 0 ? '1.2' : '1.0')
                        }}
                    </span>
                </div>
            </div>

            <!-- Service details section with no gap between service, employee, duration -->
            <div class="flex flex-col items-start self-stretch">
                <div class="text-sm font-semibold text-text-primary" *ngFor="let service of appointmentRequest?.service">
                    {{ service.name }}
                </div>
                <div class="text-sm text-text-secondary">{{ employeeName }}</div>
                <div
                    class="text-sm text-text-primary"
                    *ngIf="shouldShowServicePrice && appointmentRequest?.service && appointmentRequest.service.length > 0"
                >
                    {{ getServicesDuration(appointmentRequest.service) | duration }}
                </div>
            </div>

            <!-- Pet Information -->
            <div *ngIf="supportsPets && appointmentRequest?.petInfo?.name" class="text-sm font-semibold text-text-primary pt-2">
                {{ appointmentRequest.petInfo.name }}
            </div>
        </div>
    </div>

    <!-- Requested Times Section (Request Appointment Only) -->
    <div
        class="flex w-full flex-col bg-white rounded-md border border-base-border bg-base-bg"
        *ngIf="isRequestAppointmentOnly && appointmentRequest?.service"
    >
        <!-- Service details + price row -->
        <div class="flex justify-between items-start p-2">
            <div class="flex flex-col items-start">
                <div class="text-sm font-semibold text-text-primary" *ngFor="let service of appointmentRequest?.service">
                    {{ service.name }}
                </div>
                <div class="text-sm text-text-secondary">{{ employeeName }}</div>
                <div
                    class="text-sm font-normal text-text-primary"
                    *ngIf="shouldShowServicePrice && appointmentRequest?.service && appointmentRequest.service.length > 0"
                >
                    <ng-container *ngIf="isRequestOnlyAndFirstAvailableEmployee() && anyServiceHasDurationException()">up to </ng-container>
                    {{ getServicesDuration(appointmentRequest.service) | duration }}
                </div>
            </div>
            <div
                class="flex h-8 px-4 justify-center items-center gap-1 rounded bg-primary-light"
                *ngIf="shouldShowServicePrice && appointmentRequest?.service && appointmentRequest.service.length > 0"
            >
                <span class="text-md font-semibold text-text-primary">
                    {{
                        getServicesPrice(appointmentRequest.service)
                            | currency: currencyCode : 'symbol' : (getServicesPrice(appointmentRequest.service) % 1 != 0 ? '1.2' : '1.0')
                    }}<ng-container *ngIf="isRequestOnlyAndFirstAvailableEmployee() && anyServiceHasPriceException()">+</ng-container>
                </span>
            </div>
        </div>

        <!-- Separator -->
        <div class="border-t border-base-border mx-2"></div>

        <!-- Requested Times list -->
        <div class="flex flex-col items-start gap-2 p-2 flex-[1_0_0]">
            <div class="text-md font-semibold text-[#000] self-stretch">Requested Times</div>
            <ul class="list-disc pl-5">
                <li *ngFor="let entry of getGroupedDateTimeOfDays()" class="text-sm text-[#000] leading-6">
                    <span class="font-bold">{{ entry.date | date: 'EEE, MMM d' }}</span
                    ><span class="font-normal"> : {{ entry.labels }}</span>
                </li>
            </ul>
        </div>

        <!-- Pet Information -->
        <div *ngIf="supportsPets && appointmentRequest?.petInfo?.name" class="text-sm font-semibold text-text-primary px-4 pb-4">
            {{ appointmentRequest.petInfo.name }}
        </div>
    </div>

    <!-- Business Location -->
    <div
        class="flex py-3 px-0 flex-col items-start gap-2 self-stretch rounded-md border border-base-border bg-base-bg"
        *ngIf="siteSettings && siteSettings.businessAddress"
    >
        <div class="flex px-3 items-center gap-4 self-stretch">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="25" viewBox="0 0 18 25" fill="none" class="flex-shrink-0">
                <path
                    d="M2.25 8.84063C2.25 5.23594 5.23594 2.25 9 2.25C12.7641 2.25 15.75 5.23594 15.75 8.84063C15.75 10.9781 14.6344 13.5984 12.9891 16.2047C11.6625 18.3047 10.1297 20.1797 9 21.4594C7.87031 20.1797 6.34219 18.3094 5.01094 16.2047C3.36563 13.6031 2.25 10.9781 2.25 8.84063ZM9 0C4.03125 0 0 3.95625 0 8.84063C0 14.4328 5.63437 21.1359 7.9875 23.6906C8.54062 24.2906 9.45938 24.2906 10.0125 23.6906C12.3656 21.1359 18 14.4328 18 8.84063C18 3.95625 13.9688 0 9 0ZM7.5 9C7.5 8.60218 7.65804 8.22064 7.93934 7.93934C8.22064 7.65804 8.60218 7.5 9 7.5C9.39782 7.5 9.77936 7.65804 10.0607 7.93934C10.342 8.22064 10.5 8.60218 10.5 9C10.5 9.39782 10.342 9.77936 10.0607 10.0607C9.77936 10.342 9.39782 10.5 9 10.5C8.60218 10.5 8.22064 10.342 7.93934 10.0607C7.65804 9.77936 7.5 9.39782 7.5 9ZM12.75 9C12.75 8.00544 12.3549 7.05161 11.6517 6.34835C10.9484 5.64509 9.99456 5.25 9 5.25C8.00544 5.25 7.05161 5.64509 6.34835 6.34835C5.64509 7.05161 5.25 8.00544 5.25 9C5.25 9.99456 5.64509 10.9484 6.34835 11.6517C7.05161 12.3549 8.00544 12.75 9 12.75C9.99456 12.75 10.9484 12.3549 11.6517 11.6517C12.3549 10.9484 12.75 9.99456 12.75 9Z"
                    fill="#5D556D"
                />
            </svg>

            <div class="flex flex-col gap-1">
                <div class="text-lg font-semibold text-text-primary">{{ siteSettings.businessName }}</div>
                <div class="text-sm text-text-secondary">{{ siteSettings.businessAddress }}</div>
            </div>
        </div>
    </div>

    <!-- Contact Information and Action Buttons Container -->
    <div class="flex w-full flex-col justify-center items-start">
        <!-- Contact Information -->
        <div class="text-center text-sm text-text-primary self-stretch" *ngIf="phoneNumberExists">
            <span *ngIf="isRescheduleAppointment; else changeText">
                <span class="font-semibold">To Reschedule:</span> Head to your profile below or call:
            </span>
            <ng-template #changeText>
                <span *ngIf="isApprovalRequired; else appointmentText">To change your request, please call:</span>
                <ng-template #appointmentText>To change your appointment, please call:</ng-template>
            </ng-template>
            <br />
            <a href="tel:{{ siteSettings.businessPhoneNumber }}" class="text-primary-base text-md font-medium underline">
                {{ siteSettings.businessPhoneNumber }}
            </a>
        </div>
        <div class="text-center text-sm text-text-primary self-stretch" *ngIf="!phoneNumberExists">
            <span *ngIf="isRescheduleAppointment; else changeTextNoPhone">
                <span class="font-semibold">To Reschedule:</span> Head to your profile below or contact the business.
            </span>
            <ng-template #changeTextNoPhone>
                <span *ngIf="isApprovalRequired; else appointmentTextNoPhone">To change your request, please contact the business.</span>
                <ng-template #appointmentTextNoPhone>To change your appointment, please contact the business.</ng-template>
            </ng-template>
        </div>

        <!-- Action Buttons -->
        <div class="flex flex-col gap-2 w-full self-stretch pt-4 fixed bottom-4 max-w-[var(--dsb-content-max-width)]">
            <button hlmBtn variant="default" (click)="onClickViewProfile()" *ngIf="userLoggedIn">View My Profile</button>
            <button hlmBtn variant="outline" (click)="requestNewAppointment()">
                <span *ngIf="!isApprovalRequired">Book Another Appointment</span>
                <span *ngIf="isApprovalRequired">Request Another Appointment</span>
            </button>
        </div>
    </div>
</div>
